import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type", "dayOfMonth", "month", "year"];
import I18n from 'I18n';

// @ts-expect-error untyped module
import * as SimpleDate from 'UIComponents/core/SimpleDate';
import * as BlockedDateType from 'automation-ui-canvas/flow/constants/BlockedDateType';
import * as DisplayMonth from 'automation-ui-canvas/flow/constants/DisplayMonth';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
const toSimpleDate = (day, month, year) => {
  if (day && month && year) {
    return SimpleDate.make(year, DisplayMonth.toNumber(month), day);
  } else {
    return null;
  }
};
const toDateProperties = simpleDate => {
  const dateArr = SimpleDate.toArray(simpleDate);
  if (dateArr) {
    const [year, month, day] = dateArr;
    return {
      day,
      month: DisplayMonth.toDisplay(month),
      year
    };
  } else {
    return {
      day: null,
      month: null,
      year: null
    };
  }
};
export default class BlockedDateMetadata extends createImmutableObjectClass({
  type: BlockedDateType.STATIC,
  dayOfMonth: 0,
  month: 'JANUARY',
  year: 0
}, {
  fromJSON: _ref => {
    let {
        type,
        dayOfMonth,
        month,
        year
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    if (type === BlockedDateType.RECURRING) {
      // recurring dates aren't provided with a year, so this figures out
      // whether the current or next year should be displayed
      const today = SimpleDate.now();
      const {
        day: todayDay,
        month: todayMonth,
        year: todayYear
      } = toDateProperties(today);
      const numberMonth = DisplayMonth.toNumber(month);
      const numberTodayMonth = DisplayMonth.toNumber(todayMonth);
      const isDatePastToday = numberTodayMonth < numberMonth || numberTodayMonth === numberMonth && todayDay < dayOfMonth;
      if (!isDatePastToday) {
        year = todayYear + 1;
      } else {
        year = todayYear;
      }
    }
    return Object.assign({
      type,
      dayOfMonth,
      month,
      year
    }, rest);
  },
  toJSON: record => record
}) {
  setType(newType) {
    return this.set('type', newType);
  }
  setDate(newSimpleDate) {
    const {
      day,
      month,
      year
    } = toDateProperties(newSimpleDate);
    return this.set('dayOfMonth', day).set('month', month).set('year', year);
  }
  getType() {
    return this.get('type');
  }
  getDate() {
    const day = this.get('dayOfMonth');
    const month = this.get('month');
    const year = this.get('year');
    return toSimpleDate(day, month, year);
  }
  getDisplayDate() {
    const day = this.get('dayOfMonth');
    const month = DisplayMonth.toNumber(this.get('month'));
    const year = this.get('year');
    const type = this.get('type');
    if (type === BlockedDateType.STATIC) {
      const moment = I18n.moment({
        year,
        month,
        day
      });
      return moment.format('LL');
    } else {
      const moment = I18n.moment({
        month,
        day
      });
      return moment.format('LL');
    }
  }
}